import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=88a35cd2&scoped=true&"
import script from "./DatePicker.vue?vue&type=script&lang=js&"
export * from "./DatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a35cd2",
  null
  
)

export default component.exports